import React from 'react'

interface Props {
  onClick: () => void
}

export const ResetButton: React.FC<Props> = ({ onClick }) => {
  return (
    <div
      onClick={onClick}
      className='bg-spring-wood-50 group border-2 p-5 border-gray-600 active:bg-gray-100 mr-3 ml-3'
    >
      <svg
        xmlns='http://www.w3.org/2000/svg'
        fill='none'
        viewBox='0 0 24 24'
        // strokeWidth="1"
        stroke='currentColor'
        className='w-10 h-10 md:w-16 md:h-16 stroke-gray-500 hover:stroke-gray-900 stroke-1'
      >
        <path
          strokeLinecap='round'
          strokeLinejoin='round'
          d='M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0l3.181 3.183a8.25 8.25 0 0013.803-3.7M4.031 9.865a8.25 8.25 0 0113.803-3.7l3.181 3.182m0-4.991v4.99'
        />
      </svg>
    </div>
  )
}
